<div class="vehicle-column flex flex-col gap-1 w-full" [ngClass]="{ 'pb-1': isMobile }" #vehicleColumn>
  <div *ngIf="!isMobile" class="bar-container flex w-full h-1 overflow-hidden rounded-full mb-2">
    <div #bar class="bar h-full transition-all duration-500" *ngFor="let color of vehicle.colors"
      [ngStyle]="getBarClass(color, vehicle.colors.length)"></div>
  </div>

  <div class="flex flex-row items-end gap-1">
    <rfc-icon [iconInput]="vehicle.icon" class="block shrink-0 leading-none"></rfc-icon>
    <div class="text text-sm font-semibold leading-none text-gray-800">
      {{ vehicle.text }}
    </div>
  </div>

  <div *ngIf="vehicle?.subText" class="text-xs text-gray-500 font-normal leading-relaxed">
    {{ vehicle.subText }}
  </div>

  <div *ngIf="vehicle?.chip" class="mt-1">
    <mat-chip-set>
      <mat-chip class="chip full !min-h-[20px] !text-[10px] uppercase font-bold tracking-tighter">
        {{ vehicle.chip }}
      </mat-chip>
    </mat-chip-set>
  </div>
</div>